import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { LanguageAndConfigBoResponse } from '@utils/types/back-office/language-and-config.ts';

export interface LanguageAndConfigPayload {
  id?: number;
  bcp47: string;
  key: string;
  name: string;
  is_private?: boolean;
  is_enabled?: boolean;
  asr_url?: string;
  asr_model_location?: string;
  asr_audio_rate?: number;
  punctuation_url?: string;
  punctuation_model_location?: string;
  asr_version?: string;
  asr_common_version?: string;
  alignment_language_code?: string;
  alignment_version?: string;
  deepl_code?: string;
}

export const useCreateLanguageAndConfig = () => {
  const queryClient = useQueryClient();

  const createLanguageAndConfig = async (payload: LanguageAndConfigPayload) => {
    const response = await Axios.post<LanguageAndConfigBoResponse>(
      `${POST_URL().languageAndConfigs}`,
      payload
    );

    return response.data;
  };

  return useMutation<
    LanguageAndConfigBoResponse,
    AxiosError<BaseError>,
    LanguageAndConfigPayload
  >(createLanguageAndConfig, {
    onSuccess: () => {
      queryClient.invalidateQueries('languageAndConfig');
    },
    useErrorBoundary: false
  });
};
